//REDUX-TOOLKIT
import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface Notification {
    list: []
    badge: number,
    userActivity: {
        list: any[],
        paginate: any,
        pageLoaded: number
    },
    badgeUpdated: boolean
}

const initialState: Notification = {
    list: [],
    badge: 0,
    userActivity: {
        list: [],
        paginate: null,
        pageLoaded: 0
    },
    badgeUpdated: false
}

const slice = createSlice({
    name: "notifications",
    initialState,
    reducers: {
        setUserActivity: (state, action: PayloadAction<any>) => {
            if (action.payload.force) {
                return { ...state, userActivity: {
                    list: action.payload.activityData.list,
                    paginate: action.payload.activityData.paginate,
                    pageLoaded: action.payload.page
                },
                badge: action.payload.activityData.badgeCount }
            }
            if (action.payload.page > state.userActivity.pageLoaded)
            return { ...state, userActivity: {
                list: [...state.userActivity.list, ...action.payload.activityData.list],
                paginate: action.payload.activityData.paginate,
                pageLoaded: action.payload.page
            },
            badge: action.payload.page === 1 ? action.payload.activityData.badgeCount : 0 }
        },
        setNotificationData: (state, action: PayloadAction<any>) => {
            return { ...state, list: action.payload }
        },
        setBadge: (state, action: PayloadAction<any>) => {
            return { ...state, badge: action.payload }
        },
        setBadgeUpdated:  (state) => {
            return { ...state, badge: 0, badgeUpdated: true }
        },
        removeNotification: (state, action: PayloadAction<any>) => {
            const newArray: any = state.list.filter(
                (item: any) => item.id !== action.payload
            )

            return { ...state, list: newArray }
        },
    },
})

export const { setNotificationData, setBadge, removeNotification, setUserActivity, setBadgeUpdated } =
    slice.actions
export const selectNotificationData = (state: {
    notifications: Notification
}) => state.notifications.list
export const notification_badge = (state: { notifications: Notification }) =>
    state.notifications.badge
export const selectUserActivities = (state: { notifications: Notification }) =>
    state.notifications.userActivity
export const selectBadgeUpdated = (state: { notifications: Notification }) =>
    state.notifications.badgeUpdated
export default slice.reducer
